import { useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { userKeys } from '@/hooks/user-query-keys'
import { LoginService } from '@/http'
import type { TCredenciaisLogin, TLoginErrorResponse, TUsuarioLogado } from '@/http'

export const useLogin = () => {
  const mutation = useMutation<
    TUsuarioLogado,
    AxiosError<TLoginErrorResponse, TLoginErrorResponse>,
    TCredenciaisLogin,
    unknown
  >({
    mutationKey: userKeys.login(),
    mutationFn: async (credentiais: TCredenciaisLogin) =>
      new LoginService().execute(credentiais).then((res) => res.data),
  })
  return mutation
}
